<div class="blotter-selector-wrapper bfx-multi-selector-alternative">
  <div
    *ngIf="alternativeOptions && alternativeOptionsLabel && optionsLabel && showOptions"
    class="bfx-segmented-group-container-sm"
    flex
  >
    <button
      #selectorButton
      class="bfx-segmented-control-sm"
      [ngClass]="{'bfx-segmented-control-subtle-unselected-sm':alternativeActive, 'bfx-segmented-control-subtle-selected-sm':!alternativeActive}"
      (click)="switchToOptions()"
    >
      <span class="label-primary">{{optionsLabel}}</span>
    </button>
    <button
      #altSelectorButton
      class="bfx-segmented-control-sm"
      [ngClass]="{'bfx-segmented-control-subtle-unselected-sm':!alternativeActive, 'bfx-segmented-control-subtle-selected-sm':alternativeActive}"
      (click)="switchToAltOptions()"
    >
      <span class="label-primary">{{alternativeOptionsLabel}}</span>
    </button>
  </div>
  <div #wrapper class="bfx-multi-selector">
    <input
      [disabled]="disableInput"
      *ngIf="showOptions"
      #entry
      placeholder="Filter"
      type="search"
      class="bfx-multi-selector--input constrained ui-autocomplete-input ui-autocomplete-dd-input ui-inputtext ui-corner-all ui-state-default ui-widget ui-state-filled ui-cell-editing"
      (focus)="onInputFocus($event)"
      [ngModel]="text"
      (ngModelChange)="textChanged($event)"
    />
    <ng-container *ngIf="!showOptions">
      <label
        class="bfx-multi-selector--label"
        (click)="showOptionsOnClick()"
        [ngStyle]="{'cursor': disableInput ? 'default':'pointer'}"
        style="cursor: none"
      >
        {{selectedOptionText}}
      </label>
      <bfx-icon-button
        [tabindex]="-1"
        [disabled]="disableInput"
        size="xs"
        class="ui-button-icon-only"
        iconClass="icon-ion_chevron_down"
        (action)="showOptionsOnClick()"
      ></bfx-icon-button>
    </ng-container>
  </div>
  <div #dropdown [class]="panelStyleClass" style="display: none" appendTo="body">
    <div #listWrapper class="bfx-dropdown-selector-wrapper">
      <div class="header">
        <button
          *ngIf="!optionSingleSelection"
          class="bfx-button-secondary-subtle"
          (click)="clearAll()"
        >
          Clear All
        </button>
      </div>
      <ul #optionElemContainer class="bfx-multi-selector-options">
        <li
          #optionElem
          *ngFor="let option of shownOptions; let i = index"
          [ngClass]="{'selector-autocomplete-list-item':true,'disable': i > lastActiveIndex, 'selector-state-highlight':(highlightIndex==i)}"
          (mousemove)="onMouseMoveHighlight($event, option, optionElem, i)"
          (click)="onClick($event, option, optionElem, i)"
        >
          <label class="label" title="{{option.label}}"><span>{{option.label}}</span></label>
          <div class="bfx-checkbox-default icon" [ngClass]="{'icon-check' : option.checked}"></div>
        </li>
      </ul>
    </div>
  </div>
</div>
